<template lang="pug">
.campaign-participants-input
  el-row(:gutter="20").campaign-participants__list
    el-col(:style="{width: group === 'DOT' ? '210px' : '120px'}").campaign-participants__list-label
      span {{ $t('负责人') }}
      span(v-if="group === 'DOT'") ({{ $t('社交监测项目') }})
      i.iconfont.icon-baocun(v-if="editLeader")
      i.iconfont.icon-plan(v-else :class="{ 'disabled':!canEdit || leaderBtnDisabled }")
      el-button(
        :disabled="!canEdit || leaderBtnDisabled"
        type="text"
        @click="handleEditLeader"
      ) {{ editLeader ? $t('确认') : $t('编辑') }}
    el-col(:span="18").campaign-participants__list__input-container
      .campaign-participants__list__input-content
        template(v-if="editLeader")
          .campaign-participats__list__input(
            v-for="v, i in data.leader"
          )
            el-autocomplete(
              style="width: 180px"
              :value="data.leader[i].mail"
              @input="v => handleInput(i, v, 'leader')"
              :fetch-suggestions="querySearch"
              :trigger-on-focus="false"
              @select="v => selectLeader(i, v)"
            )
              i(
                slot="suffix"
                class="el-input__icon el-icon-circle-close"
                style="cursor: pointer"
                @click="clearLeader(i, v)"
              )
        template(v-else)
          .campaign-participats__list__input(
            v-for="v, i in data.leader"
          )
            span {{ data.leader[i].mail }}

  el-row(:gutter="20").campaign-participants__list
    el-col(style="width: 120px").campaign-participants__list-label
      span {{ $t('抄送人') }}
      i.iconfont.icon-baocun(v-if="editCopyTo")
      i.iconfont.icon-plan(v-else :class="{ 'disabled':!canEdit || copyToBtnDisabled }")
      el-button(
        :disabled="!canEdit || copyToBtnDisabled"
        type="text"
        @click="handleEditCopyTo"
      ) {{ editCopyTo ? $t('确认') : $t('编辑') }}
    el-col(:span="20").campaign-participants__list__input-container
      .campaign-participants__list__input-content
        template(v-if="editCopyTo")
          .campaign-participats__list__input(
            v-for="v, i in data.cc"
          )
            el-autocomplete(
              style="width: 180px"
              :value="data.cc[i].mail"
              @input="v => handleInput(i, v, 'cc')"
              :fetch-suggestions="querySearch"
              :trigger-on-focus="false"
              @select="v => selectCopyTo(i, v)"
            )
              i(
                slot="suffix"
                class="el-input__icon el-icon-circle-close"
                style="cursor: pointer"
                @click="clearCopyTo(i, v)"
              )
            el-button(
              icon="el-icon-delete"
              circle
              style="margin-left: 5px"
              @click="v => $emit('deleteCopyTo', i, group)"
            )
          el-button(
            type="text"
            @click="$emit('addCopyTo', group)"
          ) + {{ $t('新增抄送人') }}
        template(v-else)
          .campaign-participats__list__input(
            v-for="v, i in data.cc"
          )
            span {{ data.cc[i].mail }}

  el-row(
    :gutter="20"
    v-if="data.sow"
  ).campaign-participants__list
    el-col(style="width: 120px").campaign-participants__list-label
      span {{ $t('SOW负责人') }}
      i.iconfont.icon-baocun(v-if="editSOW")
      i.iconfont.icon-plan(v-else :class="{ 'disabled':!canEdit || SOWBtnDisabled }")
      el-button(
        :disabled="!canEdit || SOWBtnDisabled"
        type="text"
        @click="handleEditSOW"
      ) {{ editSOW ? $t('确认') : $t('编辑') }}
    el-col(:span="20").campaign-participants__list__input-container
      .campaign-participants__list__input-content__sow
        template(v-if="editSOW")
          .campaign-participats__list__input(
            v-for="v, i in data.sow"
          )
            div(v-for="(o, j) in v.leader")
              div 【{{ data.sow[i].leader[j].sub_final_scope_name }}】
              el-autocomplete(
                style="width: 180px"
                :value="data.sow[i].leader[j].mail"
                :fetch-suggestions="fetchPurchaseContactList"
                :trigger-on-focus="false"
                @select="v => selectSOW(i, j, v)"
              )
                i(
                  slot="suffix"
                  class="el-input__icon el-icon-circle-close"
                  style="cursor: pointer"
                  @click="clearSOW(i, j)"
                )
        template(v-else)
          .campaign-participats__list__input(
            v-for="v, i in data.sow"
          )
            div(v-for="(o, j) in v.leader")
              div 【{{ data.sow[i].leader[0].sub_final_scope_name }}】
              div {{ data.sow[i].leader[0].mail }}
</template>

<script>
import axios from 'axios'
import { flatten } from 'lodash'

export default {
  props: {
    data: {
      type: Object,
      default () {
        return {}
      }
    },
    canEdit: {
      type: Boolean,
      default () {
        return true
      }
    },
    group: {
      type: String,
      default () {
        return 'market'
      }
    }
  },
  data () {
    return {
      editLeader: false,
      editCopyTo: false,
      editSOW: false
    }
  },
  computed: {
    leaderBtnDisabled () {
      return this.data.leader.some(i => i.user_id == null)
    },
    copyToBtnDisabled () {
      return this.data.cc.some(i => i.user_id == null)
    }
  },
  methods: {
    querySearch (querySearch, cb) {
      axios.get('/admin/user/getUserByDept', {
        params: {
          struct_group_code: this.group === 'DOT' ? 'it' : this.group,
          keyword: querySearch
        }
      })
        .then(res => {
          res.forEach(i => { i.value = i.mail })
          cb(res)
        })
    },
    fetchPurchaseContactList (querySearch, cb) {
      axios.get('/common/getPurchaseContactList')
        .then(res => {
          res.forEach(i => { i.value = i.mail })
          cb(res)
        })
    },
    async handleEditLeader () {
      if (this.editLeader) {
        if (this.data.leader.some(i => !i.user_id)) {
          this.$message.error(this.$t('请选择负责人'))
        } else {
          if (await this.checkMailIsValid('leader')) {
            this.$message.error(this.$t('请输入正确的邮箱账号'))
          } else {
            this.editLeader = !this.editLeader
            this.$emit('confirm', this.group)
          }
        }
      } else {
        this.editLeader = !this.editLeader
      }
    },
    async handleEditCopyTo () {
      if (this.editCopyTo) {
        if (this.data.cc.some(i => !i.user_id)) {
          this.$message.error(this.$t('请选择抄送人'))
        } else {
          if (await this.checkMailIsValid('cc')) {
            this.$message.error(this.$t('请输入正确的邮箱账号'))
          } else {
            this.editCopyTo = !this.editCopyTo
            this.$emit('confirm', this.group)
          }
        }
      } else {
        this.editCopyTo = !this.editCopyTo
      }
    },
    async handleEditSOW () {
      if (this.editSOW) {
        const res = flatten(this.data.sow.map(i => i.leader))
        if (res.some(i => !i.user_id)) {
          this.$message.error(this.$t('请选择SOW负责人'))
        } else {
          this.editSOW = !this.editSOW
          this.$emit('confirmSOW')
        }
      } else {
        this.editSOW = !this.editSOW
      }
    },
    clearCopyTo (index, item) {
      this.$emit('changeCopyTo', index, {user_id: null, email: ''}, this.group)
    },
    clearLeader (index, item) {
      this.$emit('changeLeader', index, {user_id: null, email: ''}, this.group)
    },
    clearSOW (parentIndex, index, item) {
      this.$emit('changeSOW', parentIndex, index, {user_id: null, email: ''})
    },
    selectLeader (index, item) {
      this.$emit('changeLeader', index, item, this.group)
    },
    selectCopyTo (index, item) {
      this.$emit('changeCopyTo', index, item, this.group)
    },
    selectSOW (parentIndex, index, item) {
      this.$emit('changeSOW', parentIndex, index, item)
    },
    async checkMailIsValid (type) {
      const res = await Promise.all(this.data[type].map(i => axios.get('/admin/user/getUserByDept', {
        params: {
          struct_group_code: this.group === 'DOT' ? 'it' : this.group,
          keyword: i.mail
        }
      })))
      return res.some(i => i.length === 0)
    },
    handleInput (i, value, type) {
      this.$emit('changeMail', i, value, type, this.group)
    }
  }
}
</script>

<style lang="stylus">
.campaign-participants-input
  padding 20px 30px
  .iconfont
    color $dark-blue
    margin-left 10px
    &.disabled
      color #c0c4cc

.campaign-participants__list__input-content
  display flex
  flex-wrap wrap
  > .el-button
      height: 27px
      padding: 0

.campaign-participats__list__input
  width 220px
  margin-right 20px
  margin-bottom  20px
  > span
    line-height 27px
    height 28px
    display block

.campaign-participants__list,.campaign-participants__list-label
  > span
      font-size 12px
</style>
